import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import { useClientData } from './hook';
import dayjs from 'dayjs';
import { TenderDataProps } from './props';
import { Autocomplete, TextField } from '@mui/material';

const ClientForm = ({
    onChangeFormik,
    isOnlyView,
    idTender,
}: TenderDataProps) => {
    const {
        formik,
        accountManagersOptions,
        projectOptions,
        deliveryMethodOptions,
        processTypeOptions,
        otherAccountManagerParam,
        architectureManagersOptions,
        otherArchitectureManagerParam,
        statusProcessOptions,
    } = useClientData({ onChangeFormik, idTender });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={1.5} pt="20px">
                <Grid item xs={12} md={4}>
                    <DatePickerField
                        label="Fecha inicio del proceso"
                        name="startProcessDate"
                        required
                        value={
                            formik.values.startProcessDate
                                ? dayjs(formik.values.startProcessDate)
                                : null
                        }
                        onBlur={formik.handleBlur}
                        touched={formik.touched.startProcessDate}
                        errors={formik.errors.startProcessDate}
                        onChange={(value) =>
                            formik.setFieldValue(
                                'startProcessDate',
                                value,
                                true
                            )
                        }
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldText
                        label="Entidad cliente"
                        name="clientEntity"
                        required
                        value={formik.values.clientEntity}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.clientEntity}
                        errors={formik.errors.clientEntity}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldSelect
                        data={accountManagersOptions}
                        label="Gerente de cuenta"
                        name="accountManager"
                        required
                        value={formik.values.accountManager as string}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.accountManager}
                        errors={formik.errors.accountManager}
                        disabled={isOnlyView}
                    />
                </Grid>
                {formik.values.accountManager ===
                    otherAccountManagerParam?.id && (
                    <Grid item xs={12} md={4}>
                        <FieldText
                            label="Otro"
                            name="otherAccountManager"
                            required={
                                formik.values.accountManager ===
                                otherAccountManagerParam?.id
                            }
                            value={formik.values.otherAccountManager}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            touched={formik.touched.otherAccountManager}
                            errors={formik.errors.otherAccountManager}
                            disabled={isOnlyView}
                        />
                    </Grid>
                )}
                <Grid item xs={12} md={4}>
                    <FieldText
                        label="Correo Gerente de Cuenta"
                        name="accountManagerEmail"
                        required
                        value={formik.values.accountManagerEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.accountManagerEmail}
                        errors={formik.errors.accountManagerEmail}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldText
                        label="CRM"
                        name="crm"
                        required
                        value={formik.values.crm}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.crm}
                        errors={formik.errors.crm}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldSelect
                        data={architectureManagersOptions}
                        label="Gerente de arquitectura"
                        name="architectureManager"
                        required
                        value={formik.values.architectureManager as string}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.architectureManager}
                        errors={formik.errors.architectureManager}
                        disabled={isOnlyView}
                    />
                </Grid>
                {formik.values.architectureManager ===
                    otherArchitectureManagerParam?.id && (
                    <Grid item xs={12} md={4}>
                        <FieldText
                            label="Otro"
                            name="otherArchitectureManager"
                            required={
                                formik.values.architectureManager ===
                                otherArchitectureManagerParam?.id
                            }
                            value={formik.values.otherArchitectureManager}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            touched={formik.touched.otherArchitectureManager}
                            errors={formik.errors.otherArchitectureManager}
                            disabled={isOnlyView}
                        />
                    </Grid>
                )}
                <Grid item xs={12} md={4}>
                    <FieldText
                        label="Correo Gerente de Arquitectura"
                        name="architectureManagerEmail"
                        required
                        value={formik.values.architectureManagerEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.architectureManagerEmail}
                        errors={formik.errors.architectureManagerEmail}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldSelect
                        data={processTypeOptions}
                        label="Tipo de proceso"
                        name="processType"
                        required
                        value={formik.values.processType as string}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.processType}
                        errors={formik.errors.processType}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldSelect
                        data={deliveryMethodOptions}
                        label="Forma de entrega"
                        name="deliveryMethod"
                        required
                        value={formik.values.deliveryMethod as string}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.deliveryMethod}
                        errors={formik.errors.deliveryMethod}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldSelect
                        data={statusProcessOptions}
                        label="Etapa de proceso"
                        name="statusProcess"
                        value={
                            typeof formik.values.statusProcess === 'string'
                                ? formik.values.statusProcess
                                : (
                                      formik.values.statusProcess as {
                                          id?: string;
                                      }
                                )?.id ?? ''
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.statusProcess}
                        errors={formik.errors.statusProcess}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldText
                        label="Nombre proponente"
                        name="bidder"
                        required
                        value={formik.values.bidder}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.bidder}
                        errors={formik.errors.bidder}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FieldText
                        label="NIT"
                        name="nit"
                        value={formik.values.nit}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.nit}
                        errors={formik.errors.nit}
                        disabled={isOnlyView}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Autocomplete
                        disabled={isOnlyView}
                        options={projectOptions}
                        getOptionLabel={(option) => option.name}
                        value={
                            projectOptions.find(
                                (p) => p.id === formik.values.projectId
                            ) ?? null
                        }
                        onChange={(event, newValue) => {
                            formik.setFieldValue(
                                'projectId',
                                newValue?.id || ''
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Proyecto"
                                size="small"
                                fullWidth
                                error={!!formik.errors.projectId}
                                helperText={
                                    formik.touched.projectId &&
                                    formik.errors.projectId
                                }
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </form>
    );
};

export default ClientForm;
